import { render, staticRenderFns } from "./proportionCharts.vue?vue&type=template&id=3d4856e0&scoped=true&"
import script from "./proportionCharts.vue?vue&type=script&lang=js&"
export * from "./proportionCharts.vue?vue&type=script&lang=js&"
import style0 from "./proportionCharts.vue?vue&type=style&index=0&id=3d4856e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4856e0",
  null
  
)

export default component.exports